import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

type PermissionState = {
  permissions: { [permission: string]: { [action: string]: boolean } }
}

type PermissionReducer<T> = (state: PermissionState, action: PayloadAction<T>) => PermissionState;

type PermissionActions = {
  set: PermissionReducer<string[]>,
  allow: PermissionReducer<{ path: string, action: string, allowed: boolean }>,
  clear: PermissionReducer<void>
};

export const permissionsSlice = createSlice<PermissionState, PermissionActions>({
  name: "permissions",
  initialState: {
    permissions: {}
  },
  reducers: {
    set: (state, action) => {
      state.permissions = {};
      action.payload.forEach((path) => { state.permissions[path] = { view: true }; })

      return state;
    },
    allow: (state, { payload: { path, allowed, action}}) => {
      const permission = state.permissions[path] || {};
      permission[action] = allowed;

      state.permissions[path] = permission;
      return state;
    },
    clear: (state) => {
      state.permissions = {};
      return state;
    }
  }
});

export const {
  set: setPermissions,
  allow: allowAction,
  clear: clearPermissions
} = permissionsSlice.actions;
export default permissionsSlice.reducer;
